import { Injectable } from '@angular/core';

/**
 * Mock Data Service - Fornece dados de teste
 * 
 * Usado para desenvolvimento e demonstração quando o backend não está disponível
 * ou quando queremos testar com dados específicos
 */
@Injectable({ providedIn: 'root' })
export class MockDataService {
  
  /**
   * Retorna dados mock para uma entidade específica
   * @param entityName Nome da entidade/collection
   * @returns Dados mock estruturados
   */
  getMockData(entityName: string): any {
    const mockCollections: Record<string, any> = {
      'DemoProducts': this.getDemoProductsData(),
      'DemoCustomers': this.getDemoCustomersData(),
      'DemoOrders': this.getDemoOrdersData(),
    };
    
    return mockCollections[entityName] || { data: [] };
  }

  injectShopeeData() {
    const shopeeData = {
      response: {
        item_list: [
          {
            // ==========================================
            // 📋 CAMPOS PRINCIPAIS (nível raiz)
            // ==========================================
            item_sku: "11025013",
            description: "Kit Whey PRO Concentrado Max Titanium 1kg + Creatina Pura 250g Faze Nutrition + Coqueteleira 600 ML. Bem vindo a DaFábricaSuplementos. Produto 100% original com Nota Fiscal.",
            promotion_id: 205053831094503,
            item_dangerous: 0,
            update_time: 1722629279,
            category_id: 100005,
            size_chart: "",
            has_model: true,
            deboost: "FALSE",
            create_time: 1722375890,
            item_id: 22997684885,
            description_type: "normal",
            weight: "1.5",
            size_chart_id: 0,
            item_name: "Kit Whey PRO Concentrado Max Titanium 1kg + Creatina Pura 250g Faze Nutrition + Coqueteleira 600 ML",
            authorised_brand_id: 0,
            item_status: "NORMAL",
            condition: "NEW",

            // CAMPOS MAPEADOS (Master-Detail)
            // O Master-Detail usa dataPath para buscar valores.
            // Esses campos devem existir no nível raiz do item.
            days_to_ship: 2,
            is_pre_order: false,
            package_width: 17,
            package_height: 31,
            package_length: 27,
            original_brand_name: "Faze Nutrition",
            brand_id: 3996990,
            image_ratio: "1:1",

            // ==========================================
            // 🖼️ IMAGENS (arrays de primitivos → objetos)
            // ==========================================
            image: {
              image_ratio: "1:1",
              // ⚠️ Arrays de strings viram arrays de {index, value}
              image_id_list: [
                { index: 0, value: "sg-11134201-7rdyg-lyctjfbmd99k1d" },
                { index: 1, value: "br-11134207-7r98o-lycqsn62hj3910" },
                { index: 2, value: "br-11134207-7r98o-lycqsn62ixnp5c" },
                { index: 3, value: "br-11134207-7r98o-lydter3nwxetd2" },
                { index: 4, value: "br-11134207-7r98o-lygks828ec4l12" },
                { index: 5, value: "br-11134207-7r98o-lycqsn62ojxh96" },
                { index: 6, value: "br-11134207-7r98o-lycqsn62lqslff" }
              ],
              image_url_list: [
                { index: 0, value: "https://cf.shopee.com.br/file/sg-11134201-7rdyg-lyctjfbmd99k1d" },
                { index: 1, value: "https://cf.shopee.com.br/file/br-11134207-7r98o-lycqsn62hj3910" },
                { index: 2, value: "https://cf.shopee.com.br/file/br-11134207-7r98o-lycqsn62ixnp5c" },
                { index: 3, value: "https://cf.shopee.com.br/file/br-11134207-7r98o-lydter3nwxetd2" },
                { index: 4, value: "https://cf.shopee.com.br/file/br-11134207-7r98o-lygks828ec4l12" },
                { index: 5, value: "https://cf.shopee.com.br/file/br-11134207-7r98o-lycqsn62ojxh96" },
                { index: 6, value: "https://cf.shopee.com.br/file/br-11134207-7r98o-lycqsn62lqslff" }
              ]
            },

            // ==========================================
            // 🎯 IMAGENS DE PROMOÇÃO
            // ==========================================
            promotion_image: {
              image_id_list: [
                { index: 0, value: "sg-11134201-7rdyg-lyctjfbmd99k1d" }
              ],
              image_url_list: [
                { index: 0, value: "https://cf.shopee.com.br/file/sg-11134201-7rdyg-lyctjfbmd99k1d" }
              ]
            },

            // ==========================================
            // 🚚 INFORMAÇÕES LOGÍSTICAS
            // ==========================================
            logistic_info: [
              {
                estimated_shipping_fee: 10.83,
                logistic_id: 91003,
                is_free: false,
                logistic_name: "Entrega Padrão",
                size_id: 0,
                enabled: true
              }
            ],

            // ==========================================
            // 🏷️ ATRIBUTOS DO PRODUTO
            // ==========================================
            attribute_list: [
              {
                attribute_id: 100095,
                is_mandatory: false,
                original_attribute_name: "Weight",
                attribute_value_list: [
                  {
                    value_unit: "kg",
                    value_id: 0,
                    original_value_name: "1.4"
                  }
                ]
              },
              {
                attribute_id: 100104,
                is_mandatory: false,
                original_attribute_name: "Nutrient Type",
                attribute_value_list: [
                  {
                    value_unit: "",
                    value_id: 0,
                    original_value_name: "Creatina"
                  },
                  {
                    value_unit: "",
                    value_id: 1011,
                    original_value_name: "Amino Acids"
                  },
                  {
                    value_unit: "",
                    value_id: 1189,
                    original_value_name: "Protein"
                  },
                  {
                    value_unit: "",
                    value_id: 1208,
                    original_value_name: "Whey"
                  }
                ]
              },
              {
                attribute_id: 100974,
                is_mandatory: false,
                original_attribute_name: "Ingredient",
                attribute_value_list: [
                  {
                    value_unit: "",
                    value_id: 0,
                    original_value_name: "Creatina + Whey"
                  }
                ]
              }
            ],

            // ==========================================
            // 🎥 VÍDEOS DO PRODUTO
            // ==========================================
            video_info: [
              {
                duration: 18,
                video_url: "https://cvf.shopee.com.br/file/api/v4/11110105/mms/br-11110105-6kfkq-lydot7thtllh30.16000081722428480.mp4",
                thumbnail_url: "https://cf.shopee.com.br/file/br-11110105-7r98o-lydoti0kwqxy25"
              }
            ]
          },
          // ==========================================
          // 📦 SEGUNDO PRODUTO (para testar paginação)
          // ==========================================
          {
            item_sku: "11025014",
            description: "Produto exemplo 2 para demonstração de múltiplos items",
            promotion_id: 205053831094504,
            item_dangerous: 0,
            update_time: 1722629280,
            category_id: 100006,
            size_chart: "M, L, XL",
            has_model: false,
            deboost: "TRUE",
            create_time: 1722375891,
            item_id: 22997684886,
            description_type: "extended",
            weight: "2.0",
            size_chart_id: 1,
            item_name: "Produto Teste 2",
            authorised_brand_id: 1,
            item_status: "ACTIVE",
            condition: "USED",
            days_to_ship: 3,
            is_pre_order: true,
            package_width: 20,
            package_height: 35,
            package_length: 30,
            original_brand_name: "Brand Test",
            brand_id: 3996991,
            image_ratio: "1:1",
            image: {
              image_ratio: "1:1",
              image_id_list: [
                { index: 0, value: "test-id-001" },
                { index: 1, value: "test-id-002" }
              ],
              image_url_list: [
                { index: 0, value: "https://example.com/image1.jpg" },
                { index: 1, value: "https://example.com/image2.jpg" }
              ]
            },
            promotion_image: {
              image_id_list: [
                { index: 0, value: "promo-id-001" }
              ],
              image_url_list: [
                { index: 0, value: "https://example.com/promo1.jpg" }
              ]
            },
            logistic_info: [
              {
                estimated_shipping_fee: 15.50,
                logistic_id: 91004,
                is_free: true,
                logistic_name: "Entrega Expressa",
                size_id: 1,
                enabled: true
              }
            ],
            attribute_list: [
              {
                attribute_id: 100096,
                is_mandatory: true,
                original_attribute_name: "Color",
                attribute_value_list: [
                  {
                    value_unit: "",
                    value_id: 1,
                    original_value_name: "Red"
                  },
                  {
                    value_unit: "",
                    value_id: 2,
                    original_value_name: "Blue"
                  }
                ]
              }
            ],
            video_info: [
              {
                duration: 25,
                video_url: "https://example.com/video2.mp4",
                thumbnail_url: "https://example.com/thumb2.jpg"
              }
            ]
          }
        ]
      },
      warning: "",
      error: "",
      message: "",
      request_id: "test-request-id-12345",
      debug_message: ""
    };

    return shopeeData;
  }
  
  /**
   * Dados de demonstração: Catálogo de Produtos
   */
  private getDemoProductsData(): any {
    return {
      data: {
        products: [
          { id: 1, name: 'Notebook Dell Inspiron 15', category: 'Eletrônicos', price: 3500, stock: 15, active: true, description: 'Notebook com Intel i7, 16GB RAM, 512GB SSD' },
          { id: 2, name: 'Mouse Logitech MX Master 3', category: 'Eletrônicos', price: 450, stock: 50, active: true, description: 'Mouse wireless ergonômico' },
          { id: 3, name: 'Teclado Mecânico RGB', category: 'Eletrônicos', price: 650, stock: 30, active: true, description: 'Teclado mecânico com switches blue' },
          { id: 4, name: 'Monitor LG 27" 4K', category: 'Eletrônicos', price: 1200, stock: 20, active: true, description: 'Monitor IPS 4K UHD' },
          { id: 5, name: 'Webcam Logitech C920', category: 'Eletrônicos', price: 550, stock: 25, active: true, description: 'Webcam Full HD 1080p' },
          { id: 6, name: 'Headset HyperX Cloud II', category: 'Eletrônicos', price: 400, stock: 35, active: true, description: 'Headset gamer 7.1 surround' },
          { id: 7, name: 'SSD Samsung 1TB', category: 'Eletrônicos', price: 800, stock: 40, active: true, description: 'SSD NVMe M.2 1TB' },
          { id: 8, name: 'Memória RAM Corsair 16GB', category: 'Eletrônicos', price: 350, stock: 60, active: true, description: 'DDR4 3200MHz 16GB' },
          { id: 9, name: 'Placa de Vídeo RTX 3060', category: 'Eletrônicos', price: 2500, stock: 10, active: true, description: 'NVIDIA RTX 3060 12GB' },
          { id: 10, name: 'Processador Intel i7', category: 'Eletrônicos', price: 2200, stock: 12, active: true, description: 'Intel Core i7 12ª geração' },
          { id: 11, name: 'Camiseta Nike Dry-Fit', category: 'Vestuário', price: 120, stock: 100, active: true, description: 'Camiseta esportiva respirável' },
          { id: 12, name: 'Tênis Adidas Ultraboost', category: 'Vestuário', price: 800, stock: 45, active: true, description: 'Tênis para corrida' },
          { id: 13, name: 'Jaqueta North Face', category: 'Vestuário', price: 650, stock: 30, active: true, description: 'Jaqueta impermeável' },
          { id: 14, name: 'Calça Jeans Levis', category: 'Vestuário', price: 350, stock: 55, active: true, description: 'Calça jeans tradicional' },
          { id: 15, name: 'Boné New Era', category: 'Vestuário', price: 150, stock: 80, active: true, description: 'Boné ajustável' },
          { id: 16, name: 'Café Pilão 500g', category: 'Alimentos', price: 18, stock: 200, active: true, description: 'Café torrado e moído' },
          { id: 17, name: 'Açúcar Cristal 1kg', category: 'Alimentos', price: 5, stock: 300, active: true, description: 'Açúcar refinado' },
          { id: 18, name: 'Arroz Tipo 1 5kg', category: 'Alimentos', price: 28, stock: 150, active: true, description: 'Arroz branco tipo 1' },
          { id: 19, name: 'Feijão Preto 1kg', category: 'Alimentos', price: 8, stock: 180, active: true, description: 'Feijão preto tipo 1' },
          { id: 20, name: 'Óleo de Soja 900ml', category: 'Alimentos', price: 7, stock: 220, active: true, description: 'Óleo de soja refinado' },
          { id: 21, name: 'Smartphone Samsung S21', category: 'Eletrônicos', price: 2800, stock: 18, active: true, description: 'Smartphone 5G 128GB' },
          { id: 22, name: 'Tablet iPad Air', category: 'Eletrônicos', price: 4500, stock: 8, active: true, description: 'Tablet Apple 256GB' },
          { id: 23, name: 'Smart Watch Apple Watch', category: 'Eletrônicos', price: 3200, stock: 22, active: true, description: 'Relógio inteligente' },
          { id: 24, name: 'Fone Bluetooth Sony', category: 'Eletrônicos', price: 280, stock: 70, active: true, description: 'Fone sem fio com cancelamento de ruído' },
          { id: 25, name: 'Carregador Portátil 20000mAh', category: 'Eletrônicos', price: 120, stock: 90, active: true, description: 'Power bank rápido' }
        ]
      },
      filters: {
        searchText: '',
        category: ''
      }
    };
  }
  
  /**
   * Dados de demonstração: Clientes
   */
  private getDemoCustomersData(): any {
    return {
      data: {
        customers: [
          { id: 1, name: 'João Silva', email: 'joao@example.com', phone: '(11) 98765-4321', city: 'São Paulo', state: 'SP', active: true },
          { id: 2, name: 'Maria Santos', email: 'maria@example.com', phone: '(21) 97654-3210', city: 'Rio de Janeiro', state: 'RJ', active: true },
          { id: 3, name: 'Pedro Oliveira', email: 'pedro@example.com', phone: '(31) 96543-2109', city: 'Belo Horizonte', state: 'MG', active: true },
          { id: 4, name: 'Ana Costa', email: 'ana@example.com', phone: '(41) 95432-1098', city: 'Curitiba', state: 'PR', active: true },
          { id: 5, name: 'Carlos Souza', email: 'carlos@example.com', phone: '(51) 94321-0987', city: 'Porto Alegre', state: 'RS', active: false },
        ]
      }
    };
  }
  
  /**
   * Dados de demonstração: Pedidos
   */
  private getDemoOrdersData(): any {
    return {
      data: {
        orders: [
          { 
            id: 1001, 
            customerId: 1, 
            customerName: 'João Silva',
            date: '2025-10-15', 
            total: 4500, 
            status: 'Entregue',
            items: [
              { productId: 1, productName: 'Notebook Dell Inspiron 15', quantity: 1, price: 3500 },
              { productId: 2, productName: 'Mouse Logitech MX Master 3', quantity: 2, price: 450 }
            ]
          },
          { 
            id: 1002, 
            customerId: 2, 
            customerName: 'Maria Santos',
            date: '2025-10-16', 
            total: 1800, 
            status: 'Em trânsito',
            items: [
              { productId: 4, productName: 'Monitor LG 27" 4K', quantity: 1, price: 1200 },
              { productId: 5, productName: 'Webcam Logitech C920', quantity: 1, price: 550 }
            ]
          },
          { 
            id: 1003, 
            customerId: 3, 
            customerName: 'Pedro Oliveira',
            date: '2025-10-17', 
            total: 920, 
            status: 'Processando',
            items: [
              { productId: 12, productName: 'Tênis Adidas Ultraboost', quantity: 1, price: 800 },
              { productId: 15, productName: 'Boné New Era', quantity: 1, price: 150 }
            ]
          },
        ]
      }
    };
  }
}





